import { useEffect, useState } from "react";
import { firestore } from "./firebase";
import Sidebar from "./Sidebar";
import Field from "./Field";


export default function EmailSettings() {
    const [data, setData] = useState(null);

    useEffect(() => {
        firestore.collection('settings').doc('emails').get().then(doc => {
            if(doc.exists) {
                setData(doc.data());
            } else {
                setData({});
            }
        });
    }, []);

    useEffect(() => {
        if(Object.keys(data ?? {}).length === 0) return;

        firestore.collection('settings').doc('emails').update(data);
    }, [data]);

    return <div className="h-full flex w-auto">
        <Sidebar defaultOpen={false} />
        <div className="flex-grow overflow-auto">
            <div className="h-screen flex flex-col overflow-hidden">
                <div className="bg-gray-600 flex items-center text-white gap-2 p-3 justify-between">
                    <div className="text-l font-semibold">E-Mail-Einstellungen</div>
                </div>
                <div className="p-3 overflow-y-scroll">
                    <div>
                        Wähle hier aus an welche E-Mail-Adressen Benachrichtigungen über neue Events gesendet werden.
                        Es kann EINE E-Mail-Adresse im Feld "Alle Events" eingegeben werden, an die Benachrichtigungen über alle neuen Events gesendet werden.
                        Zusätzlich kann EINE WEITERE E-Mail-Adresse im Feld "Mit Sticker-Link" eingegeben werden, an die zusätzlich Benachrichtigungen über neue Events mit gebuchtem Sticker-Link gesendet werden.
                        Alle Änderungen werden automatisch gespeichert.
                    </div>
                    <Field name="Alle Events" value={data?.default_notification_email} onChange={(val) => setData({...data, ...{default_notification_email: val}})} />
                    <Field name="Mit Sticker-Link" value={data?.story_notification_email} onChange={(val) => setData({...data, ...{story_notification_email: val}})} />
                </div>
            </div>
        </div>
    </div>;
}